// extracted by mini-css-extract-plugin
export default {"recos":"I2-z","productCardOverride":"J2-z","rowHasBadge":"K2-z"};